frontApp.menu = {
  name: 'menu',
  description: 'menu scripts',
  init() {
    if ($('.js-menu').length) {
      this.rollsInit();
    }
  },
  rollsInit() {
    $('.js-menu').on('click', 'li > span', function () {
      const $cur = $(this);
      if ($cur.next('ul').length) {
        $cur.next('ul').toggle();
      }
    });
  },
};
